module.exports = __webpack_public_path__ + "media/video-thumbnails/MA-logo-spinner-transparent-a712eeb1.gif";